import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FileUpload } from "app/pages/ok-core/photo/file-upload";
import { JsonContainer } from "app/utils/json-container";
import { RestService } from "app/utils/rest-service";
import { StorageUtils } from "app/utils/storage-utils";
import { environment } from "environments/environment";
import { Comment } from "./comment";
import { FileUploadRequest } from "./fileUploadRequest";
import { Request } from "./request";
import { RequestSearch } from "./requestSearch";


@Injectable()
export class RequestService extends RestService {

    private baseUrl: string;

    constructor(private client: HttpClient, private storageUtils: StorageUtils) {
        super(client, 'request', storageUtils);
        this.baseUrl = `${environment.baseUrl}/request`;
    }

    listRequestsByClientId(search: RequestSearch, callback: (result: JsonContainer, list: any) => void) {
        this.executePost('listRequestsByClientId', search, callback)
    }

    save(request: Request, callback: (result: JsonContainer, resp: any) => void) {
        this.executePost('save', request, callback)
    }

    addComment(comment: Comment, callback: (result: JsonContainer, resp: any) => void) {
        this.executePost('addComment', comment, callback)
    }

    load(idRequest: string, callback: (result: JsonContainer, request: Request) => void) {
        this.executeGet("loadRequest/" + idRequest, callback);
    }

    uploadFile2(fileUpload: FileUpload, callback: (result: JsonContainer, list: any) => void) {
        //this.executePost('uploadFile', fileUpload, callback)
        const formData: FormData = new FormData();
    }

    uploadFile(fileUpload: FileUploadRequest, callback: (result: JsonContainer, list: any) => void) {
        const formData: FormData = new FormData();
        formData.append('file', fileUpload.file);
        if (fileUpload.company_id) formData.append('company_id', fileUpload.company_id);
        if (fileUpload.requestId) formData.append('requestId', fileUpload.requestId);
        if (fileUpload.type) formData.append('type', fileUpload.type);
        if (fileUpload.department) formData.append('department', fileUpload.department);
        if (fileUpload.competence) formData.append('competence', fileUpload.competence);
        if (fileUpload.typeUser) formData.append('typeUser', fileUpload.typeUser);

        const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${this.storageUtils.getToken()}`)
            .set('Access-Control-Allow-Origin', '*')
            .set('Access-Control-Allow-Headers', 'Content-Type');

        const url = `${this.baseUrl}/uploadFile`;  // Use a URL completa
        this.client.post<JsonContainer>(url, formData, { headers }).subscribe(
            (result) => {
                const list = (result as any)['list'] || null;
                callback(result, list);
            },
            (error) => console.error('Erro ao fazer upload', error)
        );
    }

    uploadFileComment(fileUpload: FileUploadRequest, callback: (result: JsonContainer, list: any) => void) {
        const formData: FormData = new FormData();
        formData.append('file', fileUpload.file);
        if (fileUpload.company_id) formData.append('company_id', fileUpload.company_id);
        if (fileUpload.requestId) formData.append('requestId', fileUpload.requestId);
        if (fileUpload.type) formData.append('type', fileUpload.type);
        if (fileUpload.department) formData.append('department', fileUpload.department);
        if (fileUpload.competence) formData.append('competence', fileUpload.competence);
        if (fileUpload.typeUser) formData.append('typeUser', fileUpload.typeUser);

        const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${this.storageUtils.getToken()}`)
            .set('Access-Control-Allow-Origin', '*')
            .set('Access-Control-Allow-Headers', 'Content-Type');

        const url = `${this.baseUrl}/uploadFileComment`;  // Use a URL completa
        this.client.post<JsonContainer>(url, formData, { headers }).subscribe(
            (result) => {
                const list = (result as any) || null;
                callback(result, list);
            },
            (error) => console.error('Erro ao fazer upload', error)
        );
    }
}


